import i18n from '@/plugins/i18n';
export default {
  items: [
    { name: i18n.t("DASHBOARD"), url: "/dashboard", icon: "icon-speedometer" },
 
   
    

  ]
};
